module.exports = __webpack_public_path__ + "static/media/Telecomunicaciones.82f5f08d.mp4";